import CkEditorContainer from "../../../components/miscellaneous/editors/ckEditor";

const CkEditors = () => {
  return <CkEditorContainer />;
};

export default CkEditors;
